//Clase de la aplicacion BextDocUI
//Autor:Marlon Granda-Fecha:04/23/2019 - Mail:mar_gran2003@yahoo.com.ar
//Empresa:Marlon Granda

import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './components/home/home.component';

import { RUsuarioComponent } from './components/bussines/rusuario/rusuario.component';

import { LTLogAppComponent } from './components/bussines/ltlog-app/ltlog-app.component';

import { OrgChartJsComponent } from './components/org-chart/org-chart-js/org-chart-js.component';
import { GeneralFormComponent } from './components/controls/general-form/general-form.component';

import { AdminTodoPermisosComponent } from './components/admin-todo-permisos/admin-todo-permisos.component';
//import { SolicitudRadicadoSalidaComponent } from './components/bussines/solicitudes/salida/solicitud-radicado-salida/solicitud-radicado-salida.component';
import { SolicitudPqrdComponent } from './components/bussines/solicitudes/pqrs/solicitud-pqrd/solicitud-pqrd.component';
import { ExternalPqrsComponent } from './components/bussines/external-pqrs/external-pqrs.component';

import { RPaginaComponent } from './components/bussines/rpagina/rpagina.component';
import { ExternalPqrsContactComponent } from './components/bussines/external-pqrs-contact/external-pqrs-contact.component';
import { ConsultaExternalPqrsComponent } from './components/bussines/consulta-external-pqrs/consulta-external-pqrs.component';
import { DocumentValidateExternalPqrsComponent } from './components/bussines/document-validate-external-pqrs/document-validate-external-pqrs.component';
import { HomeExternalPqrsComponent } from './components/bussines/home-external-pqrs/home-external-pqrs.component';
import { RecoveryExternalPqrsPasswordComponent } from './components/bussines/recovery-external-pqrs-password/recovery-external-pqrs-password.component';
import { GuiaUsoExternalPqrsComponent } from './components/bussines/guia-uso-external-pqrs/guia-uso-external-pqrs.component';
import { InitPqrsComponent } from './components/bussines/init-pqrs/init-pqrs.component';

export let APP_ROUTES: Routes = [

  /*{ path: 'OrgChartJs', component: OrgChartJsComponent },
  { path: 'Home', component: HomeComponent },

  { path: 'UbicacionFisicaExpediente', component: GeneralFormComponent }, //TUbicacionFisicaExpedienteComponent

  
  { path: 'EstadoCarga', component: GeneralFormComponent },
  { path: 'Usuario', component: RUsuarioComponent }, //RUsuarioComponent

  { path: 'TipoSeguridadDocumento', component: GeneralFormComponent }, //RTipoSeguridadDocumentoComponent
  // { path: 'TipoMoneda', component: RTipoMonedaComponent },
  // { path: 'TipoDisposicion', component: RTipoDisposicionComponent },
  { path: 'TipoDatoBasico', component: GeneralFormComponent }, //RTipoDatoBasicoComponent

  { path: 'TipoAreaEmpresa', component: GeneralFormComponent },//RTipoAreaEmpresaComponent
  { path: 'TemaSolicitud', component: GeneralFormComponent },
  { path: 'Tema', component: GeneralFormComponent },//RTemaComponent
  { path: 'TablaRetencionDocumental', component: GeneralFormComponent },// RTablaRetencionDocumentalComponent },
  { path: 'SubSerie', component: GeneralFormComponent }, //RSubSerieComponent
  { path: 'Serie', component: GeneralFormComponent }, //RSerieComponent
  { path: 'SedeEmpresa', component: GeneralFormComponent }, //RSedeEmpresaComponent
  { path: 'Role', component: GeneralFormComponent }, //RRoleComponent



  { path: 'Pais', component: GeneralFormComponent }, //RPaisComponent

  { path: 'Menu', component: GeneralFormComponent }, //RMenuComponent

  { path: 'MedioDeContactoEmpresa', component: GeneralFormComponent }, //RMedioDeContactoEmpresaComponent 
  { path: 'MedioDeContactoContacto', component: GeneralFormComponent }, //RMedioDeContactoContactoComponent
  { path: 'Grupo', component: GeneralFormComponent }, //RGrupoComponent
  { path: 'Empresa', component: GeneralFormComponent },//REmpresaComponent

  { path: 'DiaFestivo', component: GeneralFormComponent },
  { path: 'Departamento', component: GeneralFormComponent }, //RDepartamentoComponent
  { path: 'DatoBasico', component: GeneralFormComponent }, //RDatoBasicoComponent
  { path: 'Contacto', component: GeneralFormComponent }, //RContactoComponent
    

  { path: 'Ciudad', component: GeneralFormComponent }, //RCiudadComponent
  { path: 'Carpeta', component: GeneralFormComponent }, //RCarpetaComponent

  { path: 'AreaEmpresa', component: GeneralFormComponent },// RAreaEmpresaComponent },

  { path: 'TLogApp', component: LTLogAppComponent },
  { path: 'AdminTodoPermisos', component: AdminTodoPermisosComponent },*/
  //{ path: 'SolicitudRadicadoSalida', component: SolicitudRadicadoSalidaComponent },
  //{ path: 'SolicitudPqrd', component: SolicitudPqrdComponent },
  { path: 'ExternalPQRs', component: ExternalPqrsComponent },
  { path: 'Pagina', component: RPaginaComponent },
  { path: 'ExternalPQRContact', component: ExternalPqrsContactComponent }, //RContactoComponent
  { path: 'ConsultaExternalPQR', component: ConsultaExternalPqrsComponent },
  { path: 'HomeExternalPQR', component: HomeExternalPqrsComponent },
  { path: 'RecuperarContrasena', component: RecoveryExternalPqrsPasswordComponent },
  { path: 'ValidarDocumentoExternalPqrs', component: DocumentValidateExternalPqrsComponent },
  { path: 'GuiaUsoExternalPqrs', component: GuiaUsoExternalPqrsComponent },
  //{ path: 'InitPQRs', component: InitPqrsComponent },
  { path: '**', pathMatch: 'full', redirectTo: 'HomeExternalPQR' }
  //{ path: '**', pathMatch: 'full', redirectTo: 'InitPQRs' }
  //{ path: '**', pathMatch: 'full', redirectTo: 'ExternalPQRs' }
  //{ path: 'TEST', component: GeneralFormComponent },
  // { path: '**', pathMatch: 'full', redirectTo: 'Home' }
]

//treetest
export const AppRoutes: any = RouterModule.forRoot(APP_ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules });